import React, { useEffect } from 'react';

const RobotsTxt: React.FC = () => {
  useEffect(() => {
    const generateRobotsTxt = () => {
      const robotsContent = `User-agent: *
Allow: /

# Sitemaps
Sitemap: https://carolinatrophyroofs.com/sitemap-index.xml
Sitemap: https://carolinatrophyroofs.com/sitemap.xml
Sitemap: https://carolinatrophyroofs.com/sitemap-blog.xml
Sitemap: https://carolinatrophyroofs.com/sitemap-locations.xml
Sitemap: https://carolinatrophyroofs.com/sitemap-images.xml

# Disallow admin and internal pages
Disallow: /admin
Disallow: /auth
Disallow: /api/
Disallow: /_next/
Disallow: /tmp/

# Allow important pages
Allow: /blog
Allow: /locations
Allow: /services
Allow: /contact
Allow: /quote
Allow: /book-inspection

# Crawl-delay for courtesy
Crawl-delay: 1

# Host directive
Host: https://carolinatrophyroofs.com`;

      // Clear body and display robots.txt content
      document.body.innerHTML = '';
      document.body.style.fontFamily = 'monospace';
      document.body.style.whiteSpace = 'pre-wrap';
      document.body.style.fontSize = '12px';
      document.body.style.lineHeight = '1.4';
      document.body.style.padding = '0';
      document.body.style.margin = '0';
      document.body.textContent = robotsContent;

      // Set proper headers
      document.title = 'robots.txt';
      const metaContentType = document.querySelector('meta[http-equiv="Content-Type"]');
      if (metaContentType) {
        metaContentType.setAttribute('content', 'text/plain; charset=utf-8');
      } else {
        const newMeta = document.createElement('meta');
        newMeta.setAttribute('http-equiv', 'Content-Type');
        newMeta.setAttribute('content', 'text/plain; charset=utf-8');
        document.head.appendChild(newMeta);
      }
    };

    generateRobotsTxt();
  }, []);

  return null;
};

export default RobotsTxt;